import Logo from "./Logo";
import { SiAmericanexpress, SiMastercard, SiStripe, SiVisa } from "react-icons/si";

const BADGES = [
  { name: "Stripe", Icon: SiStripe },
  { name: "Visa", Icon: SiVisa },
  { name: "Mastercard", Icon: SiMastercard },
  { name: "Amex", Icon: SiAmericanexpress },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/5 py-16 md:py-24" data-testid="footer">
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-10 px-6 lg:px-10">
        <div className="flex items-center gap-2.5">
          <Logo className="h-9 w-9" />
          <span className="font-display text-lg font-semibold tracking-tight text-white">
            StartX <span className="text-teal-300">Powered</span>
          </span>
        </div>

        <div
          className="flex flex-wrap items-center justify-center gap-3"
          data-testid="footer-payment-badges"
        >
          {BADGES.map(({ name, Icon }) => (
            <span
              key={name}
              className="flex items-center gap-2 rounded-lg border border-white/10 bg-white/[0.03] px-3.5 py-2 text-xs font-medium text-slate-400"
            >
              <Icon className="h-4 w-4 text-slate-300" />
              {name}
            </span>
          ))}
        </div>

        <div className="flex flex-col items-center gap-5 md:flex-row md:gap-8">
          <p className="text-xs text-slate-500">
            &copy; 2026 StartX Powered. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="#"
              className="text-xs text-slate-500 transition-colors duration-300 hover:text-white"
              data-testid="footer-privacy-link"
            >
              Privacy Policy
            </a>
            <a
              href="#"
              className="text-xs text-slate-500 transition-colors duration-300 hover:text-white"
              data-testid="footer-terms-link"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
